namespace $ {

	/** Owns one passive wire subscription. Never refreshes or executes its publisher. */
	export class $shm_hitalama_map_retain_lease extends $mol_wire_pub {
		private publisher?: $mol_wire_pub
		private position = 0

		constructor( publisher: $mol_wire_pub ) {
			super()
			this.publisher = publisher
			this.position = publisher.sub_on( this, 0 )
		}

		matches( publisher: $mol_wire_pub ) { return this.publisher === publisher }
		absorb() { /* Invalidation is retained lazily, not scheduled in the background. */ }
		peer_repos( _publisher_position: number, subscriber_position: number ) { this.position = subscriber_position }
		pub_off() { this.publisher = undefined }

		destructor() {
			const publisher = this.publisher
			this.publisher = undefined
			publisher?.sub_off( this.position )
		}
	}
}
